import { atom, useSetAtom } from 'jotai';
import React, { useContext } from 'react';
import Dialog from '@smart-tv/components/dialog';
import ErrorDialogContent from './error-dialog-content';
import useBackKeyLayer from '@smart-tv/hooks/use-back-key-layer';
import { networkErrorMessage } from '@smart-tv/contexts/error-context/error-context';
import { StreamContext } from '@smart-tv/contexts/stream-context';
import { StreamType } from '@smart-tv/typings/content';
import closeTvApp from '@smart-tv/utils/closeTvApp';
import { isErrorDialogOpenAtom } from '@smart-tv/atoms';

export interface Props {
  title: string;
  message: string;
  primaryButton?: Button;
  secondaryButton?: Button;
  kmmError?: boolean;
}

export interface Button {
  label: string;
  onClick: () => void;
}

export const retryButtonText = 'Prøv igen';

export const avoidDefaultErrorRedirectAtom = atom(false);

export const ErrorDialog = (props: Props) => {
  const { title, message, primaryButton, secondaryButton, kmmError } = props;
  const { streamType } = useContext(StreamContext);
  const setErrorOpen = useSetAtom(isErrorDialogOpenAtom);

  // Captures every back key press while the dialog is open, so nothing behind it reacts
  useBackKeyLayer(() => {
    // we still handle network errors separately
    if (message !== networkErrorMessage) {
      !secondaryButton && primaryButton?.onClick();
      return;
    }
    if (
      streamType &&
      (streamType === StreamType.Vod || streamType === StreamType.CatchUp) &&
      secondaryButton
    ) {
      secondaryButton.onClick();
    } else {
      closeTvApp();
    }
  });

  React.useEffect(() => {
    if (kmmError) {
      setErrorOpen(true);
    }
  }, []);

  return (
    <Dialog
      open={true}
      disableEscapeKeyDown={true}
      showCloseButton={false}
      onClose={() => secondaryButton?.onClick()}
    >
      <ErrorDialogContent
        title={title}
        message={message}
        primaryButton={primaryButton}
        secondaryButton={secondaryButton}
      />
    </Dialog>
  );
};

export default ErrorDialog;
